module.exports = __webpack_public_path__ + "media/assets/icons/mdi_speedometer-medium-078febdd15147f82bb98058936e6485f.svg";